export enum DocumentType {
  TermsAndConditions = 0,
  UserAgreement = 1,
  OrderPdfFooter = 2,
  PrivacyStatement = 3,
}
